import { EServiceGroup, NUMBER_OFFER_MAX } from "@constants";
import { ICart } from "@features/cart/ICart";
import { hasOfferBroadband, selectOfferInCartByServiceGroup } from "@utils/offerUtils";

/**
 * Validates if the Cart step is valid
 * Checks:
 * - Cart must exist
 * - If broadband offer in cart and not preorder:
 *   - Appointment must exist
 * - If broadband offer in cart:
 *   - Number of additional allowed broadband subscriptions must be >= 0
 * - If broadband offer in cart but no mobile in cart or linked to account:
 *   - Cart is invalid if nbrAdditionalAllowedMobileSubscriptions === NUMBER_OFFER_MAX
 */
export const isCartStepValid = (cart: ICart): boolean => {
    if (hasOfferBroadband(cart.offers)) {
        const broadbandOffer = selectOfferInCartByServiceGroup(cart, EServiceGroup.SA_BB);
        if (broadbandOffer) {
            const isPreOrder = broadbandOffer.prequal?.isPreOrder;

            if (!isPreOrder && !broadbandOffer.appointment) {
                return false;
            }
        }

        if (cart.nbrAdditionalAllowedBroadbandSubscriptions < 0) {
            return false;
        }

        // Check if mobile is required
        const hasMobileInCart = Boolean(selectOfferInCartByServiceGroup(cart, EServiceGroup.MOBILE));
        if (!hasMobileInCart && cart.nbrAdditionalAllowedMobileSubscriptions === NUMBER_OFFER_MAX) {
            return false;
        }
    }

    return true;
};
